import actionTypes from '../actionTypes';

const initialState = {
  status: null,
  error: null,
  message: '',
  marketingContent: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PROFILE_GET_ERROR:
      return {
        status: action.type,
        error: action.error,
      };

    case actionTypes.PROFILE_GET_REQUEST:
    case actionTypes.PROFILE_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.PROFILE_GET_SUCCESS:
      return {
        ...state,
        ...action.data,
        status: action.type,
      };

    case actionTypes.PROFILE_UPDATE_ERROR:
      return { ...state, status: action.type, error: action.error };

    case actionTypes.PROFILE_UPDATE_SUCCESS:
      return { ...state, status: action.type, ...action.data };

    case actionTypes.USER_UPDATE_SUCCESS:
      if (state.id === action.user.id) {
        return { ...state, ...action.user };
      } else {
        return state;
      }

    case actionTypes.PHONE_VERIFY_REQUEST:
    case actionTypes.PHONE_VERIFY_CHECK_REQUEST:
      return { ...state, status: action.type, message: '' };

    case actionTypes.PHONE_VERIFY_SUCCESS:
    case actionTypes.PHONE_VERIFY_ERROR:
    case actionTypes.PHONE_VERIFY_CHECK_SUCCESS:
    case actionTypes.PHONE_VERIFY_CHECK_ERROR:
      return { ...state, status: action.type, message: action.message };

    case actionTypes.PASSWORD_CHANGE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.PASSWORD_CHANGE_ERROR:
      return { ...state, status: action.type, error: action.error };

    case actionTypes.PASSWORD_CHANGE_SUCCESS:
      return { ...state, status: action.type };

    case actionTypes.GET_MARKETING_CONTENT_REQUEST:
    case actionTypes.GET_MARKETING_CONTENT_ERROR:
      return { ...state, status: action.type, marketingContent: null };

    case actionTypes.GET_MARKETING_CONTENT_SUCCESS:
      return { ...state, status: action.type, marketingContent: action.result };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/profile.js